import {useState,useEffect} from "react";
import Chart from "react-apexcharts";
import schedulePayService from '../../services/SchedulePayService';

const formatCurrency = (value) => {
    return new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
    }).format(value);
};

export default function Card({ year }) {
    const [totalsInvoice, setTotalsInvoice] = useState({
        withInvoice: 0,
        withOutInvoice: 0
    });

    useEffect(() => {
        schedulePayService.getTotalsByYear(year)
            .then(res => {
                setTotalsInvoice({
                    withInvoice: Number(res.data.withInvoice),
                    withOutInvoice: Number(res.data.withOutInvoice)
                });
            })
        .catch(console.error);
    }, []);

  const series = [
    {
      name: "Importi",
      data: [
        totalsInvoice.withInvoice,
        totalsInvoice.withOutInvoice
      ]
    }
  ];

  const options = {
    chart: {
      type: "bar",
    },
    xaxis: {
      categories: ["Fatture emesse", "Fatture da emettere"]
    },
    dataLabels: {
      enabled: true,
      formatter: v => formatCurrency(v)
    },
    tooltip: {
      y: {
        formatter: v => formatCurrency(v)
      }
    },
    colors: ["#4f46e5"]
  };

  const seriesv2 = [
      {
        name: "Fatturato",
        data: [
          1200, // Gennaio
          1500, // Febbraio
          1100, // Marzo
          1800, // Aprile
          2000, // Maggio
          2300, // Giugno
          2100, // Luglio
          1900, // Agosto
          2500, // Settembre
          2700, // Ottobre
          3000, // Novembre
          3400  // Dicembre
        ]
      }
    ];

      const optionsv2 = {
        chart: {
          type: "line",
          toolbar: { show: false }
        },
        stroke: {
          curve: "smooth",
          width: 3
        },
        xaxis: {
          categories: [
            "Gen", "Feb", "Mar", "Apr", "Mag", "Giu",
            "Lug", "Ago", "Set", "Ott", "Nov", "Dic"
          ]
        },
        yaxis: {
          labels: {
            formatter: val => `${val.toLocaleString("it-IT")} €`
          }
        },
        tooltip: {
          y: {
            formatter: val => `${val.toLocaleString("it-IT")} €`
          }
        },
        markers: {
          size: 5
        },
        colors: ["#4f46e5"]
      };
  	return (
        <div className="col-md-6 col-xxl-4 mb-6">
            <div className="card h-100">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h5 className="card-title m-0 me-2">Sezione Uno</h5>
                </div>
                <Chart
                    options={options}
                    series={series}
                    type="bar"
                    height={300}
                />

         <Chart
           options={optionsv2}
           series={seriesv2}
           type="line"
           height={320}
         />

            </div>
        </div>
	);
}